import { useMemo } from 'react';
import { Api_AdPlacementType } from '@core/api';
import { useStore } from '@core/widgets/store';
/**
 * Hook is used to get the autoplay positions configure for Retail Media feed
 */
export const useRetailMediaAutoplayPositions = () => {
    const appContext = useStore((state) => state.appContext);
    return useMemo(() => {
        return appContext?.adConfig?.placements?.find((placement) => placement.placement_type === Api_AdPlacementType.RM_INFEED)?.autoplay_positions;
    }, [appContext]);
};
